module.exports = __webpack_public_path__ + "img/VBET.ae9d5c8b.svg";